var React = require('react');

function MailIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20.9357 6.84456C22.0695 6.66498 22.9972 7.4573 22.9972 8.60528V21.1287C22.9972 22.2767 22.0695 23.3629 20.9357 23.5424L4.44337 26.1546C3.30953 26.3342 2.38184 25.5418 2.38184 24.3939V11.8704C2.38184 10.7225 3.30953 9.63627 4.44337 9.45669L20.9357 6.84456ZM12.6899 15.4561L20.936 8.93195L4.44374 11.5441L12.6899 15.4561Z","fill":"#E2231A"}));
}

MailIcon.defaultProps = {"width":"26","height":"30","viewBox":"0 0 26 30","fill":"none"};

module.exports = MailIcon;

MailIcon.default = MailIcon;
